import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
import { Section, SectionHeading } from './Shared';
const faqs = [{
  q: 'È adatto a chi sta iniziando?',
  a: 'Il pack è pensato soprattutto per istruttori e praticanti che hanno già iniziato a studiare Qi Gong, Tai Chi o Chi Kung e vogliono insegnare con maggiore struttura. Può essere utile anche a chi è agli inizi dell’insegnamento, ma non sostituisce la formazione tecnica con un insegnante qualificato.'
}, {
  q: 'Come ricevo il materiale?',
  a: 'Dopo il pagamento riceverai le indicazioni per accedere ai materiali digitali in formato PDF.'
}, {
  q: 'Devo stampare tutto?',
  a: 'No. Puoi consultare i volumi da computer, tablet o smartphone. Puoi anche stampare le schede e i materiali che desideri utilizzare durante la preparazione o il lavoro con gli allievi.'
}, {
  q: 'È un corso video?',
  a: 'No. È una raccolta digitale di volumi e strumenti pratici da consultare. È pensata per aiutarti a progettare e condurre le lezioni con maggiore ordine.'
}, {
  q: 'Ricevo un attestato?',
  a: 'No. Il MEGA PACK QI GONG™ è un prodotto editoriale e operativo, non un corso certificato, e non rilascia qualifiche professionali.'
}, {
  q: 'Posso condividere i file con altri istruttori?',
  a: 'No. L’acquisto è destinato all’uso personale. I materiali non possono essere redistribuiti, rivenduti o condivisi senza autorizzazione.'
}, {
  q: 'Il pagamento è sicuro?',
  a: 'Sì. Il pagamento viene gestito tramite una piattaforma sicura. Al termine riceverai le istruzioni per accedere al materiale.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-71" data-mp="wz77ouqjar6n">
      <SectionHeading eyebrow="Domande frequenti" className="mb-12" data-id="element-72" data-mp="ww1n9ssuodh9">
        Le domande che riceviamo più spesso
      </SectionHeading>

      <div className="glass-panel rounded-sm divide-y divide-brand-purpleDark/10" data-id="element-73" data-mp="n0hpf0uq74pv">
        {faqs.map((faq, i) => <div key={faq.q} data-id="element-74" data-mp="2pmwv7l9j656d" data-mpi={i}>
            <button type="button" aria-expanded={openIndex === i} onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-5 md:px-7 py-5 text-left flex justify-between items-center gap-6 focus:outline-none focus-visible:ring-1 focus-visible:ring-brand-gold hover:bg-brand-surfaceLight/40 transition-colors" data-id="element-75" data-mp="2po7xthr8p6vw">
              <span className="font-display font-semibold text-base md:text-lg text-brand-purpleDark" data-id="element-76" data-mp="2avwaagrlkitc">
                {faq.q}
              </span>
              <Plus className={`w-4 h-4 text-brand-goldDark transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-77" data-mp="33nfzqieset3s" />
            </button>
            <AnimatePresence initial={false} data-id="element-78" data-mp="2ulq6r859bm3w">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} className="overflow-hidden" data-id="element-79" data-mp="2ulgknvnc1z3h">
                  <p className="px-5 md:px-7 pb-6 text-brand-text/85 text-sm md:text-base leading-relaxed max-w-2xl" data-id="element-80" data-mp="2q3wmkvgdgkz">
                    {faq.a}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
};